import { ReactElement } from 'react'
import { useHistory } from 'react-router'

const useSegmentAlgoliaApi = (
  clickedResultId?: string,
  clickedResultName?: string,
  algoliaIndex?: string,
  queryID?: string,
  cardPosition?: number,
  searchText?: string,
  url?: string,
) => {
  const history = useHistory()
  const analytics = () => {
    const url = history.location.search.replace('?', '')
    let modifyPage: string
    let cardIndex: number

    let page: string
    if (url.indexOf('page') !== -1) {
      page = url.substring(url.indexOf('page') + 5)
      if (page.indexOf('&') !== -1) {
        modifyPage = page.substring(0, page.indexOf('&'))
      } else {
        modifyPage = page
      }
    } else {
      modifyPage = '1'
    }

    if (cardPosition === undefined) {
      cardIndex = 0
    } else {
      cardIndex = cardPosition
    }

    window.analytics.track(
      'Product Clicked',
      {
        objectID: clickedResultId,
        index: algoliaIndex,
        objectName: clickedResultName,
        queryID: queryID,
        query: searchText,
        position: cardIndex,
        page: modifyPage,
      },
      redirectContentCardClicked,
    )
  }

  const redirectContentCardClicked = () => {
    if (url !== undefined) {
      window.location.assign(url)
    }
  }
  return analytics
}

export default useSegmentAlgoliaApi
